import Button from "components/atoms/Button";
import { useNavigate } from "react-router-dom";
import { makeLangUrl } from "helpers/makeLangUrl";
import url from "url/index";
import useTranslate from "hooks/useTranslate";
import Timer from "components/atoms/Timer";
import RewardsItem from "../Rewards/RewardsItem";
import "../FortuneWheelModal/styles.sass";
import { useFortuneWheelStore } from "../../store/fortuneWheel";
import { FORTUNE_WHEEL_STEPS } from "../../type/FortuneWheel";
import "./styles.sass";

const FortuneWheelWinModalContent: React.FC = () => {
  const t = useTranslate();
  const navigate = useNavigate();
  const prizeSection = useFortuneWheelStore((s) => s.prizeSection);
  const step = useFortuneWheelStore((s) => s.step);
  const nextAt = useFortuneWheelStore((s) => s.nextAvailableAt);

  const handleClick = () => {
    navigate(makeLangUrl(url.routes.profile.bonus()));
  };

  const isZero = step === FORTUNE_WHEEL_STEPS.FAILED;

  return (
    <>
      <img
        src={
          isZero
            ? "https://diswdgcu9cfva.cloudfront.net/fortune-wheel/glory/win_zero_popup.webp"
            : "https://diswdgcu9cfva.cloudfront.net/fortune-wheel/glory/win_popup.webp"
        }
        width={500}
        height={297}
        alt="fortune_wheel_win_popup"
      />
      <div className="FortuneWheelModal__content">
        <div className="FortuneWheelModal__title">
          {t(
            isZero
              ? "wheel.fortune.popup.fail.header"
              : "wheel.fortune.popup.success.header",
          )}
        </div>

        {prizeSection && <RewardsItem item={{ ...prizeSection }} popup />}

        {!isZero && (
          <div className="FortuneWheelModal__subtitle">
            {t("wheel.fortune.popup.success.desc")}
          </div>
        )}

        {isZero && (
          <div className="FortuneWheelWinModalContent__timer">
            <div className="FortuneWheelWinModalContent__timer_title">
              {t("wheel.fortune.not.available")}
            </div>
            <Timer finishDate={nextAt} isWheel />
          </div>
        )}

        <Button
          variation="primary"
          label={
            isZero
              ? "wheel.fortune.popup.fail.button"
              : "wheel.fortune.popup.success.button"
          }
          onClick={handleClick}
        />
      </div>
    </>
  );
};

export default FortuneWheelWinModalContent;
